import React from 'react';

import 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './cookieConsent.css';

class CookieConsent extends React.Component {
  componentDidMount() {
    if (
      !document.getElementById('cc--main') &&
      window &&
      window.initCookieConsent
    ) {
      window.CookieConsentApi = window.initCookieConsent();
      window.CookieConsentApi.run({
        current_lang: 'sk',
        autoclear_cookies: true, // default: false
        page_scripts: true, // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        // auto_language: null                     // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: true, // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function (user_preferences, cookie) {
          // callback triggered only once
        },

        onAccept: function (cookie) {
          // window.initReactGA(cookie)
        },

        onChange: function (cookie, changed_preferences) {
          if (
            (changed_preferences.includes('marketing') ||
              changed_preferences.includes('statistics')) &&
            typeof window !== 'undefined' &&
            window &&
            window.location
          ) {
            window.location.reload();
          }
        },

        languages: {
          en: {
            consent_modal: {
              title: 'We use cookies!',
              description:
                'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
              primary_btn: {
                text: 'Accept all',
                role: 'accept_all', // 'accept_selected' or 'accept_all'
              },
              secondary_btn: {
                text: 'Reject all',
                role: 'accept_necessary', // 'settings' or 'accept_necessary'
              },
            },
            settings_modal: {
              title: 'Cookie preferences',
              save_settings_btn: 'Save settings',
              accept_all_btn: 'Accept all',
              reject_all_btn: 'Reject all',
              close_btn_label: 'Close',
              cookie_table_headers: [
                { col1: 'Name' },
                { col2: 'Domain' },
                { col3: 'Expiration' },
                { col4: 'Description' },
              ],
              blocks: [
                {
                  title: 'Cookie usage 📢',
                  description:
                    'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.',
                },
                {
                  title: 'Strictly necessary cookies',
                  description:
                    'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                  toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                  },
                },
                {
                  title: 'Performance and Analytics cookies',
                  description:
                    'These cookies allow the website to remember the choices you have made in the past',
                  toggle: {
                    value: 'analytics', // your cookie category
                    enabled: false,
                    readonly: false,
                  },
                  // cookie_table: [
                  //   // list of all expected cookies
                  //   {
                  //     col1: '^_ga', // match all cookies starting with "_ga"
                  //     col2: 'google.com',
                  //     col3: '2 years',
                  //     col4: 'description ...',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '_gid',
                  //     col2: 'google.com',
                  //     col3: '1 day',
                  //     col4: 'description ...',
                  //   },
                  // ],
                },
                {
                  title: 'Advertisement and Targeting cookies',
                  description:
                    'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                  toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false,
                  },
                },
                {
                  title: 'More information',
                  description:
                    'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                },
              ],
            },
          },
          sk: {
            consent_modal: {
              title: 'Táto webstránka používa súbory cookies',
              description:
                'Súbory cookie používame na zhromažďovanie a analýzu informácií o výkone a používaní stránok, na poskytovanie funkcií sociálnych médií a na vylepšenie a prispôsobenie obsahu a reklám. Cookies sú kategorizované a viete sa rozhodnúť, ktorú z nich povolíte. <button type="button" data-cc="c-settings" class="cc-link">Prispôsobiť</button>',
              primary_btn: {
                text: 'Povoliť všetko',
                role: 'accept_all', // 'accept_selected' or 'accept_all'
              },
              secondary_btn: {
                text: 'Odmietnuť všetko',
                role: 'accept_necessary', // 'settings' or 'accept_necessary'
              },
            },
            settings_modal: {
              title: 'Nastavenie cookies',
              save_settings_btn: 'Uložiť nastavenia',
              accept_all_btn: 'Povoliť všetko',
              reject_all_btn: 'Odmietnuť všetko',
              close_btn_label: 'Zatvoriť',
              cookie_table_headers: [{ col1: 'Meno' }],
              blocks: [
                {
                  title: 'Použitie cookies',
                  description:
                    'Súbory cookie používame na zhromažďovanie a analýzu informácií o výkone a používaní stránok, na poskytovanie funkcií sociálnych médií a na vylepšenie a prispôsobenie obsahu a reklám. Cookies sú kategorizované a viete sa rozhodnúť, ktorú z nich povolíte.',
                },
                {
                  title: 'Nevyhnutné cookies',
                  description:
                    'Nevyhnutné cookies pomáhajú vytvárať použiteľné webové stránky tak, že umožňujú základné funkcie, ako je navigácia stránky a prístup k chráneným oblastiam webových stránok. Webové stránky nemôžu riadne fungovať bez týchto súborov cookies.',
                  toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true,
                  },
                  // cookie_table: [
                  //   {
                  //     col1: '^cc_cookie',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^ARRAffinitySameSite',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^ARRAffinity',
                  //     is_regex: true,
                  //   },
                  // ],
                },
                // {
                //   title: 'Preferenčné cookies',
                //   description:
                //     'Preferenčné cookies umožňujú internetovej stránke zapamätať si informácie, ktoré zmenia spôsob, akým sa webová stránka chová alebo vyzerá, ako napr. váš preferovaný jazyk alebo región, v ktorom sa práve nachádzate.',
                //   toggle: {
                //     value: 'preferences',
                //     enabled: false,
                //     readonly: false,
                //   },
                //   // cookie_table: [
                //   //     {
                //   //         col1: '^La',
                //   //         is_regex: true
                //   //     }
                //   // ]
                // },
                {
                  title: 'Štatistické cookies',
                  description:
                    'Štatistické cookies pomáhajú majiteľom webových stránok, aby pochopili, ako komunikovať s návštevníkmi webových stránok prostredníctvom zberu a hlásenia informácií anonymne.',
                  toggle: {
                    value: 'statistics',
                    enabled: false,
                    readonly: false,
                  },
                  // cookie_table: [
                  //   {
                  //     col1: '^_ga',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^_gid',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^_gcl_au',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^_dc_gtm_UA-116859870-1',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^_ga_0HRNG7P967',
                  //     is_regex: true,
                  //   },
                  // ],
                },
                {
                  title: 'Marketingové cookies',
                  description:
                    'Marketingové cookies sa používajú na sledovanie návštevníkov na webových stránkach. Zámerom je zobrazovať reklamy, ktoré sú relevantné a pútavé pre jednotlivých užívateľov, a tým cennejšie pre vydavateľov a inzerentov tretích strán.',
                  toggle: {
                    value: 'marketing',
                    enabled: false,
                    readonly: false,
                  },
                  // cookie_table: [
                  //   {
                  //     col1: '^_fb',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^_fbp',
                  //     is_regex: true,
                  //   },
                  //   {
                  //     col1: '^PAPVisitorId',
                  //     is_regex: true,
                  //   },
                  // ],
                },
              ],
            },
          },
        },
        gui_options: {
          consent_modal: {
            layout: 'cloud', // box/cloud/bar
            position: 'bottom center', // bottom/middle/top + left/right/center
            transition: 'zoom', // zoom/slide
            swap_buttons: false, // enable to invert buttons
          },
          settings_modal: {
            layout: 'box', // box/bar
            // position: 'left',           // left/right
            transition: 'slide', // zoom/slide
          },
        },
      });
    }
  }

  render() {
    return null;
  }
}

export default CookieConsent;




// WEBPACK FOOTER //
// ./src/app/component/cookies/cookieConsent.js